import * as Common from '@/agiles/common';

export enum MasterBaseStatus {
    NotPosted = 1, // 未確定
    Posted =2, // 確定
    Editing = 4, // 編集中
    NotAvailable =8, // 使用不可
    OtherThanPosted =NotPosted | Editing | NotAvailable, // 確定以外
}

export abstract class MasterBase extends Common.StateObject {
  constructor(className: string) {
    super(className);
  }
  public get actionTooltip() {
    if (!this.lastUpdatedOn) return '必須項目(★マーク)を入力して【追加する】をクリックします。';      
    else if (this.state == MasterBaseStatus.NotPosted)　return '使用を開始する場合は【確定】をクリックします。';
    else if (this.state == MasterBaseStatus.Posted) return '内容を編集する場合は【確定取消】をクリックします。';
    else if (this.state == MasterBaseStatus.Editing) return '使用を開始する場合は【確定】をクリックします。';    
    else if (this.state == MasterBaseStatus.NotAvailable) return '使用を再開する場合は【再使用】をクリックします。';        
    else return '';
  }  
  public get actionIsAlert() {
    return !this.lastUpdatedOn || this.state == MasterBaseStatus.NotPosted || this.state == MasterBaseStatus.Editing;
  }
  public get messageOnEdit():string { 
    switch(this.state){
      case MasterBaseStatus.Posted:return '「確定取消」をクリックして状態を「編集中」に戻してから編集してください。';
      case MasterBaseStatus.NotAvailable:return '「再使用」をクリックして状態を「編集中」に戻してから編集してください。';
      default: return super.messageOnEdit;
    }
  }  
  public get messageOnDelete():string {
    switch(this.state){
      case MasterBaseStatus.Posted:
      case MasterBaseStatus.NotAvailable:
        return 'ワークフローが進行しているため削除できません。\r\nワークフローのボタンを操作し、状態を「編集中」にしてから削除してください。';
      default: return super.messageOnDelete;
    }
  }
  public isDeletable(api: Common.Api):boolean{        
    //既定動作をオーバーライド
    if (api.tenantSettings.deletablePostedMaster) return true;
    else return super.isDeletable(api);
  }  
  public getTargetState(stateId : number, actionFlag : Common.DefaultActionFlags){
    //編集=>確定・使用不可
    if (actionFlag == Common.DefaultActionFlags.edit && (stateId == MasterBaseStatus.Posted || stateId == MasterBaseStatus.NotAvailable))
      return MasterBaseStatus.Editing;
    //削除=>なし
    //更新=>未確定・編集中
    else if (actionFlag == Common.DefaultActionFlags.update && (stateId == MasterBaseStatus.NotPosted || stateId == MasterBaseStatus.Editing ))
      return MasterBaseStatus.Posted;  
    else if (actionFlag == Common.DefaultActionFlags.add && stateId == MasterBaseStatus.NotPosted)
      return MasterBaseStatus.Posted;      
    else
      return 0;
  }    
}